import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getGaUserId} from "../tracking_utils/get_ga_user_id";

export const searchHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("search", {...payload, gaId: getGaUserId()}), 500);
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getGaUserId} from "../tracking_utils/get_ga_user_id";

export const searchHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("search", {...payload, gaId: getGaUserId()}), 500);
